import { useEffect, useState } from "react";
import useAPIs from "./useAPIs";
import { AppUtils } from "./AppUtils";
import WishToaster from "../components/WishToaster";

const useSales = (distributorId) => {
  const { postData, getData, postFormData, downloadFile } = useAPIs();
  const [orderTypes, SetOrderTypes] = useState(null);

  const fetchMyOrders = (payload, onSuccess, onError) => {
    postData(
      "/reports/vo-fetch-dist-my-orders",
      payload,
      (data) => {
        onSuccess && onSuccess(data);
      },
      (error) => {
        onError && onError(error);
      }
    );
  };

  const fetchOrderTypes = () => {
    getData("/sales/v1/master/ordertypes", (data) => {
      SetOrderTypes(data);
    });
  };
  const fetchOrGenerateStoreLink = (flag, onSuccess, onError) => {
    let payload = {};
    payload.distributor_id = JSON.parse(localStorage.getItem("distributor"))?.distributor_id;
    postData(
      flag ? `/enrollment/fetch-store-link` : `/enrollment/generate-store-link`,
      payload,
      (data) => {
        onSuccess && onSuccess(data);
      },
      (error) => {
        onError && onError(error);
      }
    );
  };
  const getOrderDetails = (payload, onSuccess, onError) => {
    postData(
      `/reports/fetch-dist-order-details`,
      payload,
      (data) => {
        onSuccess && onSuccess(data);
      },
      (error) => {
        onError && onError(error);
      }
    );
  };
  const fetchOrderStatuses = (onSuccess, onError) => {
    getData(
      "/sales/v1/master/shipment-statuses",
      (data) => {
        onSuccess && onSuccess(data);
      },
      (error) => {
        onError && onError(error);
      }
    );
  };
  const fetchReplacmentReasons = (onSuccess, onError) => {
    getData(
      "/sales/v1/master/replacement-reasons",
      (data) => {
        onSuccess && onSuccess(data);
      },
      (error) => {
        onError && onError(error);
      }
    );
  };
  // New cancellation flow
  const processOrder = (payload, onSuccess, onError) => {
    postData(
      "/sales/v1/process-order",
      payload,
      (data) => {
        onSuccess && onSuccess(data);
      },
      (error) => {
        WishToaster({
          toastMessage: error ? error : "Something went wrong!",
          toastType: "error",
        });
        onError && onError(error);
      }
    );
  };

  const confirmedOrderCancellation = (payload, onSuccess, onError) => {
    postData(
      "/sales/v1/confirmed-order-cancellation",
      payload,
      (data) => {
        onSuccess && onSuccess(data);
      },
      (error) => {
        WishToaster({
          toastMessage: error ? error : "Something went wrong!",
          toastType: "error",
        });
        onError && onError(error);
      }
    );
  };
  const replacementRequest = (payload, onSuccess, onError) => {
    postData(
      "/sales/v1/order-damage-replacement-request",
      payload,
      (data) => {
        onSuccess && onSuccess(data);
      },
      (error) => {
        WishToaster({
          toastMessage: error ? error : "Something went wrong!",
          toastType: "error",
        });
        onError && onError(error);
      }
    );
  };
  const replacementRequestFileUpload = (payload, onSuccess, onError) => {
    postFormData(
      "/sales/v1/order-damage-replacement-doc-upload",
      payload,
      (data) => {
        onSuccess && onSuccess(data);
      },
      (error) => {
        WishToaster({
          toastMessage: error ? error : "Something went wrong!",
          toastType: "error",
        });
        onError && onError(error);
      }
    );
  };
  const downloadInvoice = (URL, onSuccess, onError) => {
    downloadFile(
      AppUtils.filterBaseUrl(URL),
      (data) => {
        onSuccess && onSuccess(data);
      },
      (error) => {
        onError && onError(error);
      }
    );
  };
  const initiateBulkOrderPrint = (payload, onSuccess, onError) => {
    postData(
      "/reports/download-bulk-order",
      payload,
      (data, response) => {
        onSuccess && onSuccess(data, response);
      },
      (error) => {
        WishToaster({
          toastMessage: error ? error : "Something went wrong!",
          toastType: "error",
        });
        onError && onError(error);
      }
    );
  };
  const downloadVOTMConsolidated = (payload, onSuccess, onError) => {
    postData(
      "/reports/fetch-consolidated-votm-invoice-log",
      payload,
      (data, response) => {
        onSuccess && onSuccess(data, response);
      },
      (error) => {
        WishToaster({
          toastMessage: error ? error : "Something went wrong!",
          toastType: "error",
        });
        onError && onError(error);
      }
    );
  };
  const downloadCreditNote = (payload, onSuccess, onError) => {
    postData(
      "/reports/fetch-credit-note",
      payload,
      (data, response) => {
        onSuccess && onSuccess(data, response);
      },
      (error) => {
        WishToaster({
          toastMessage: error ? error : "Something went wrong!",
          toastType: "error",
        });
        onError && onError(error);
      }
    );
  };
  const sendOTP = (payload, onSuccess, onError) => {
    postData(
      "/auth/send-otp-to-customer-phone",
      payload,
      (data) => {
        onSuccess && onSuccess(data);
      },
      (error) => {
        onError && onError(error);
      }
    );
  };
  const reVerifyPhoneNumber = (payload, onSuccess, onError) => {
    postData(
      "/auth/reverify-customer-phone",
      payload,
      (data) => {
        onSuccess && onSuccess(data);
      },
      (error) => {
        onError && onError(error);
      }
    );
  };
  const verifyCustomerPhoneOtp = (payload, onSuccess, onError) => {
    postData(
      "/auth/vo/verify-customer-phone-otp",
      payload,
      (data) => {
        onSuccess && onSuccess(data);
      },
      (error) => {
        onError && onError(error);
      }
    );
  };
  const verifyCustomerPhone = (payload, onSuccess, onError) => {
    postData(
      "/auth/vo/verify-customer-phone",
      payload,
      (data) => {
        onSuccess && onSuccess(data);
      },
      (error) => {
        onError && onError(error);
      }
    );
  };
  const customerSignUp = (payload, onSuccess, onError) => {
    postData(
      "/auth/vo/customer-sign-up",
      payload,
      (data) => {
        onSuccess && onSuccess(data);
      },
      (error) => {
        onError && onError(error);
      }
    );
  };
  const fetchMarketingProducts = (payload, onSuccess, onError) => {
    postData(
      "/sales/v1/available-vv-products",
      payload,
      (data) => {
        onSuccess && onSuccess(data);
      },
      (error) => {
        onError && onError(error);
      }
    );
  };
  const callMarketingOrderSummary = (payload, onSuccess, onError) => {
    postData(
      "/sales/v1/vv-order-summary",
      payload,
      (data) => {
        onSuccess && onSuccess(data);
      },
      (error) => {
        onError && onError(error);
      }
    );
  };
  const placeOrderMarketing = (payload, onSuccess, onError) => {
    postData(
      "/sales/v1/place-vv-order",
      payload,
      (data) => {
        onSuccess && onSuccess(data);
      },
      (error) => {
        onError && onError(error);
      }
    );
  };
  const orderPaymentMarketing = (payload, onSuccess, onError) => {
    postData(
      "/sales/v1/vv-order-payment",
      payload,
      (data) => {
        onSuccess && onSuccess(data);
      },
      (error) => {
        onError && onError(error);
      }
    );
  };
  const fetchSalesRegister = (payload, onSuccess, onError) => {
    postData(
      "/sales/v1/bo-vv-sales-register-report",
      payload,
      (data) => {
        onSuccess && onSuccess(data);
      },
      (error) => {
        onError && onError(error);
      }
    );
  };
  const fetchVVinvoiceData = (payload, onSuccess, onError) => {
    postData(
      "/sales/v1/download-bulk-vv-order",
      payload,
      (data) => {
        onSuccess && onSuccess(data);
      },
      (error) => {
        onError && onError(error);
      }
    );
  };

  const fetchAddress = (payload, onSuccess, onError) => {
    postData(
      "/enrollment/dist-address-list",
      payload,
      (data) => {
        onSuccess && onSuccess(data);
      },
      (error) => {
        onError && onError(error);
      }
    );
  };

  // Event Sales APIs
  const checkEvent = (payload, onSuccess, onError) => {
    postData(
      "/sales/v1/check-event",
      payload,
      (data) => {
        onSuccess && onSuccess(data);
      },
      (error) => {
        onError && onError(error);
      }
    );
  };

  const fetchEventMarketingProducts = (payload, onSuccess, onError) => {
    postData(
      "/sales/v1/event-marketing-collaterals-products",
      payload,
      (data) => {
        onSuccess && onSuccess(data);
      },
      (error) => {
        onError && onError(error);
      }
    );
  };

  const fetchEventWarehouses = (stateId, onSuccess, onError) => {
    getData(
      `/sales/v1/event/warehouse/list?state_id=${stateId}`,
      (data) => {
        onSuccess && onSuccess(data);
      },
      (error) => {
        onError && onError(error);
      }
    );
  };

  const fetchEventDistributorAddress = (payload, onSuccess, onError) => {
    postData(
      "/enrollment/event/dist-address-details",
      payload,
      (data) => {
        onSuccess && onSuccess(data);
      },
      (error) => {
        onError && onError(error);
      }
    );
  };

  const requestKuwaitStoreLink = (payload, onSuccess, onError) => {
    postData(
      "/enrollment/request-kuwait-store-link",
      payload,
      (data) => {
        onSuccess && onSuccess(data);
      },
      (error) => {
        onError && onError(error);
      }
    );
  };

  const fetchKuwaitStoreLink = (payload, onSuccess, onError) => {
    postData(
      "/enrollment/fetch-kuwait-store-link",
      payload,
      (data) => {
        onSuccess && onSuccess(data);
      },
      (error) => {
        onError && onError(error);
      }
    );
  };

  return {
    fetchOrGenerateStoreLink,
    fetchMyOrders,
    fetchOrderTypes,
    getOrderDetails,
    fetchReplacmentReasons,
    fetchOrderStatuses,
    processOrder,
    confirmedOrderCancellation,
    replacementRequest,
    replacementRequestFileUpload,
    downloadInvoice,
    initiateBulkOrderPrint,
    downloadVOTMConsolidated,
    downloadCreditNote,
    sendOTP,
    reVerifyPhoneNumber,
    verifyCustomerPhoneOtp,
    verifyCustomerPhone,
    customerSignUp,
    fetchMarketingProducts,
    callMarketingOrderSummary,
    placeOrderMarketing,
    orderPaymentMarketing,
    fetchSalesRegister,
    fetchVVinvoiceData,
    fetchAddress,
    checkEvent,
    fetchEventMarketingProducts,
    fetchEventWarehouses,
    fetchEventDistributorAddress,
    requestKuwaitStoreLink,
    fetchKuwaitStoreLink,
  };
};

export default useSales;
